import * as React from 'react';
import { Link } from 'react-router-dom';
import CountryService from '../../services/CountryService';
import Image from '../Image';
import { buildNavLinkUrl } from '../../helpers/categories/buildNavLinkUrl';

interface ISubCategoryProps {
  selected: GQL.ICategory;
  categories: Array<GQL.ICategory>;
}

class SubCategory extends React.Component<ISubCategoryProps> {

  render() {
    const { language, countryCode, currencyCodePageParam } = CountryService.GetInstance();
    const { selected, categories } = this.props;

    if (!selected || !categories) {
      return null;
    }

    const subcategoryList = categories.filter((category: GQL.ICategory) => category.parentCategoryId === selected.id);
    if (!subcategoryList || subcategoryList.length === 0) {
      return null;
    }

    return (
      <div className="subcategory">
        <div className="row no-gutters">
          {subcategoryList.map((category: GQL.ICategory) => (
            <div className="col-12 col-sm-6 col-md-4" key={category.id}>
              <div className="category">
                <Link to={buildNavLinkUrl(category.slug[language], countryCode, currencyCodePageParam)} className="d-flex align-items-center">
                  {category.image &&
                    <Image image={category.image} width={120} height={120} />}
                  {category.name[language]}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SubCategory;


// WEBPACK FOOTER //
// ./src/components/SubCategory/SubCategory.tsx